import { create } from 'zustand'
import type { Utente } from '@/types'

interface AuthState {
  utente: Utente | null
  isAuthenticated: boolean
  bootstrapped: boolean
  setUtente: (u: Utente) => void
  clearAuth: () => void
  setBootstrapped: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  utente: null,
  isAuthenticated: false,
  bootstrapped: false,
  setUtente: (u) => set({ utente: u, isAuthenticated: true, bootstrapped: true }),
  clearAuth: () => set({ utente: null, isAuthenticated: false, bootstrapped: true }),
  setBootstrapped: () => set({ bootstrapped: true }),
}))
